"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CuratedCollections() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="228238" id="your-local-it-partners-in-rapid-city" className="relative min-h-screen w-full overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 w-full h-full z-0">
        <img src="https://quick-cod-1.10web.cloud/wp-content/uploads/2026/04/RAA5135-2-scaled.jpg" alt="Black Hills Landscape" className="w-full h-full object-cover transition-transform duration-[20s] ease-linear scale-105" />
        {}
        <div className="absolute inset-0 bg-black/40 pointer-events-none"></div>
      </div>

      {}
      <div className="relative z-10 w-full px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div ref={contentRef} className={`max-w-2xl transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="font-default font-bold text-5xl leading-[1.1] text-white tracking-tighter ![margin:0px_0px_32px_0px] w-full md:!w-[800px] md:text-6xl lg:text-7xl">
              IT Support That Feels Right
            </h2>
            
            <p className="font-default text-lg text-white/90 mb-12 leading-relaxed max-w-xl">
              Rapid Tech Works brings enterprise-level IT to Rapid City small businesses with a personal touch. We're passionate people who love helping our neighbors thrive through technology.
            </p>
            
            <div className="flex flex-col sm:flex-row flex-wrap gap-4">
              <Button asChild variant="default" size="lg" className="rounded-full px-8 py-6 bg-primary text-primary-foreground hover:bg-primary/90 text-base font-semibold shadow-lg shadow-primary/20">
                <Link to="/ContactPage">
                  Get Started
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="rounded-full px-8 py-6 border-white text-white hover:bg-white hover:text-secondary text-base font-semibold bg-transparent">
                <Link to="/ManagedServicesPage">
                  Our Services
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}